import styled from '@emotion/styled/macro';
import { colors } from '../../../../common/styles/theme.styles';

export const DetailContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: auto;
  
  .back-section {
    padding: 20px;
    border-bottom: 1px solid ${colors.gray3};
    background: #fff;
  }
`;

export const DetailHeader = styled.div`
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BackButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  padding: 0;
  border: none;
  color: ${colors.darkGray1};
  font-family: Circular;
  font-weight: 500;
  font-size: 16px;
  line-height: normal;
  cursor: pointer;
  
  svg {
    width: 16px;
    height: 16px;
    transform: rotate(180deg);
    stroke: ${colors.darkGray1};
    stroke-width: 1.5px;
  }
`;

export const EntityHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const EntityIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${props => props.color || '#DACEE0'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-family: Circular;
  font-weight: 500;
  font-size: 16px;
  color: ${colors.darkGray1};
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const EntityInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

export const EntityName = styled.div`
  font-family: Circular;
  font-weight: 500;
  font-size: 16px;
  line-height: normal;
  text-align: center;
  color: ${colors.darkGray1};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EntityDescription = styled.div`
  font-family: Circular;
  font-weight: 450;
  font-size: 12px;
  line-height: normal;
  color: ${colors.darkGray3};
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ArrowLinkFilterIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 16px 12px;
`;

export const ItemsSection = styled.div`
  margin-bottom: 32px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemSectionTitle = styled.div`
  font-family: Circular;
  font-weight: 450;
  font-size: 12px;
  color: ${colors.darkGray3};
  padding: 0 0 8px 16px;
`;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  
  .item-name {
    font-family: Circular;
    font-weight: 500;
    font-size: 14px;
    color: ${colors.darkGray1};
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ArrowLinkIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  opacity: 0;
  svg {
    flex-shrink: 0;
  }
`;

export const ItemCard = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  transition: all 0.2s ease;
  padding: 12px;
  cursor: pointer;
  
  &:hover {
    background: ${colors.lightGray1};
    ${ItemInfo} {
      .item-name {
        text-decoration: underline;
        }
      }
    ${ArrowLinkIconWrapper} {
      opacity: 1;
    }
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  text-align: center;
  
  .empty-title {
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    color: ${colors.darkGray1};
  }
`;

export const LearnMoreButton = styled.button`
  display: flex;
  padding: 8px 20px 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: ${colors.lightGray1};
  border-radius: 10px;
  color: ${colors.darkGray1};
  font-family: Circular;
  font-weight: 450;
  font-size: 14px;
  line-height: normal;
  cursor: pointer;
  border: none;
  
  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`; 